import React, {useEffect} from 'react';
import MainTable from "../../components/main/MainTable";
import MT from "../../components/contents/home/MT";
import {useDispatch} from 'react-redux';
import {fetchResults} from '../../redux/actions/resultActions';

const MainPage = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchResults())
    }, [dispatch]);

    return (
        <div id="dnw-page">
            <div id="dnw-main">
                <div className="dnw-sheet">
                    <MainTable>
                        <MT/>
                    </MainTable>
                </div>
            </div>
        </div>
    )
};


export default MainPage;
